import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { FeatureFlagProvider } from 'contexts/FeatureFlagContext'
import { StandaloneProvisioningProvider } from 'contexts/StandaloneProvisioningContext'
import { setGoogleApiLicenseKey } from '@the-platform-group/component-library'

setGoogleApiLicenseKey(import.meta.env.VITE_GMAPS_KEY)

ReactDOM.render(
  <FeatureFlagProvider>
    <StandaloneProvisioningProvider>
      <App />
    </StandaloneProvisioningProvider>
  </FeatureFlagProvider>,
  document.getElementById('root'),
)
